import Reveal from "@/components/Reveal";

export default function SectionHeader({ num, label }) {
  return (
    <Reveal>
      <div className="mb-12 flex items-end gap-6">
        <span className="font-heading text-6xl font-extrabold leading-none text-plz-orange/90 sm:text-7xl">
          {num}
        </span>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-plz-orange">{label}</p>
          <div className="mt-3 h-px w-24 bg-plz-line" />
        </div>
      </div>
    </Reveal>
  );
}
